var _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _g, _path9, _path0, _path1, _path10, _path11, _path12, _path13, _path14, _path15, _path16, _path17, _path18, _path19, _path20, _path21, _path22, _path23, _g2, _path24, _path25, _path26, _path27, _path28, _path29, _path30, _path31, _path32, _path33, _path34, _path35, _path36, _path37, _path38, _ellipse, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgOinqMoneyHappy = function SvgOinqMoneyHappy(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    fill: "none",
    viewBox: "0 0 172 171"
  }, props), /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#oinq-money-happy_svg__a)"
  }, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#25BB66",
    d: "M53.997 109.409s-9.916-5.373-12.866-9.329c0 0-3.505-1.96-3.992 1.841-3.82.871-2.514 4.609-.434 7.898s16.945 17.983 22.108 17.867c5.163-.117 6.783-10.19 6.783-10.19s.168-2.562-11.599-8.087"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fill: "#0C1C2C",
    d: "M38.963 112.567a24.5 24.5 0 0 1-2.248-2.75c-2.08-3.289-3.385-7.027.433-7.898.488-3.801 3.994-1.836 3.994-1.836.957 1.279 2.642 2.709 4.486 4.052a17.67 17.67 0 0 0-6.665 8.432"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    fill: "#25BB66",
    d: "M126.184 72.379s3.89-9.789 3.611-14.57c0 0 1.335-3.507 3.997-.765 3.282-1.434 4.612 2.258 5.111 6.026s-1.296 23.713-5.094 26.499-11.078-4.311-11.078-4.311-1.675-1.942 3.453-12.88"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    fill: "#0C1C2C",
    d: "M138.95 66.503a24 24 0 0 0-.049-3.436c-.499-3.769-1.83-7.465-5.113-6.03-2.661-2.743-3.996.765-3.996.765.088 1.544-.262 3.621-.773 5.717a17.5 17.5 0 0 1 9.931 2.984"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    fill: "#2BD675",
    d: "M156.796 91.071a10.5 10.5 0 0 1-1.768.985c-.749.359-1.393.629-1.837.794.293-5.089-5.738-10.329-10.258-8.253-2.084.958-2.397 1.326-3.062 3.495a4.974 4.974 0 0 0 2.3 5.696 11.3 11.3 0 0 0 7.411 1.796c-1.078 3.629-3.812 4.963-7.326 6.228a23.4 23.4 0 0 1-5.401 1.457l.151.429a6.06 6.06 0 0 1 .07 3.8c5.89-1.2 11.727-4.221 14.335-9.319q.77-1.264 1.249-2.658.109-.307.191-.618a7.58 7.58 0 0 0 4.596-2.102c2.149-2.176 1.854-6.06 1.88-6.06a4.4 4.4 0 0 1-.288 1.502 6.3 6.3 0 0 1-2.243 2.828m-6.692 1.045c-.715 1.18-2.854 1.161-4.778-.034s-2.934-3.126-2.219-4.306 2.854-1.162 4.781.041c1.927 1.204 2.923 3.121 2.216 4.299"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    fill: "#2BD675",
    d: "M124.607 67.249a8.5 8.5 0 0 1-1.853-6.865c1.072-6.308.453-14.957-6.412-12.803-5.384 1.69-10.021 5.327-12.776 7.848a8.14 8.14 0 0 1-5.059 2.127c-7.479.403-13.83 2.288-15.664 2.988q-.551.209-1.123.341a48.5 48.5 0 0 0-14.2 5.819c-1.73 1.055-3.772 1.466-5.77 1.115-3.667-.645-9.66-1.235-15.213.288-6.872 1.885-2.848 9.366 1.423 14.097 1.902 2.106 2.577 5.042 1.88 7.792l-.012.048c-6.159 24.243 4.44 53.254 30.21 56.596q.4.051.802.062c5.125.153 14.263-.275 25.308-3.759 13.429-4.236 25.953-9.891 32.649-25.762.163-.387.614-2.36.716-2.768 3.135-12.626-6.014-36.492-14.906-47.164"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    fill: "#2BD675",
    d: "M124.607 67.249a8.5 8.5 0 0 1-1.853-6.865c1.072-6.308.453-14.957-6.412-12.803-5.384 1.69-10.021 5.327-12.776 7.848a8.14 8.14 0 0 1-5.059 2.127c-7.479.403-13.83 2.288-15.664 2.988q-.551.209-1.123.341a48.5 48.5 0 0 0-14.2 5.819c-1.73 1.055-3.772 1.466-5.77 1.115-3.667-.645-9.66-1.235-15.213.288-6.872 1.885-2.848 9.366 1.423 14.097 1.902 2.106 2.577 5.042 1.88 7.792l-.012.048c-6.159 24.243 4.44 53.254 30.21 56.596q.4.051.802.062c5.125.153 14.263-.275 25.308-3.759 13.429-4.236 25.953-9.891 32.649-25.762.163-.387.614-2.36.716-2.768 3.135-12.626-6.014-36.492-14.906-47.164"
  })), /*#__PURE__*/React.createElement("mask", {
    id: "oinq-money-happy_svg__b",
    width: 99,
    height: 100,
    x: 42,
    y: 47,
    maskUnits: "userSpaceOnUse",
    style: {
      maskType: "luminance"
    }
  }, _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "M124.607 67.249a8.5 8.5 0 0 1-1.853-6.865c1.072-6.308.453-14.957-6.412-12.803-5.384 1.69-10.021 5.327-12.776 7.848a8.14 8.14 0 0 1-5.059 2.127c-7.479.403-13.83 2.288-15.664 2.988q-.551.209-1.123.341a48.5 48.5 0 0 0-14.2 5.819c-1.73 1.055-3.772 1.466-5.77 1.115-3.667-.645-9.66-1.235-15.213.288-6.872 1.885-2.848 9.366 1.423 14.097 1.902 2.106 2.577 5.042 1.88 7.792l-.012.048c-6.159 24.243 4.44 53.254 30.21 56.596q.4.051.802.062c5.125.153 14.263-.275 25.308-3.759 13.429-4.236 25.953-9.891 32.649-25.762.163-.387.614-2.36.716-2.768 3.135-12.626-6.014-36.492-14.906-47.164"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#oinq-money-happy_svg__b)"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#28CC6F",
    d: "M13.666 87.467c.454-1.53 6.604-12.188 6.604-12.188l15.198.347 3.102 4.109L49.785 92.05s-2.47 12.06 12.059 35.014c4.355 6.881 18.597 23.66 40.047 23.277 7.541-.134-45.39 14.23-45.39 14.23s-12.236-28.207-17.76-50.485-25.075-26.62-25.075-26.62"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#77E4A6",
    d: "M124.129 63.37c23.998 54.302 8 64.255-14.642 79.505l20.166-9.598 13.562-14.894 2.071-6.478s1.15-10.121.721-12.117c0 0 .706-15.968-19.05-37.47z"
  }))), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    fill: "#77E4A6",
    d: "M108.508 59.836s8.514 2.764 10.113 4.352c1.604-.704 1.936-8.813.774-11.22-1.162-2.409-8.056.319-10.887 6.868M62.036 75.548s-5.662 6.932-6.142 9.131c-1.728.281-6.401-6.366-6.716-9.013-.317-2.652 6.928-4.1 12.858-.118"
  })), _path0 || (_path0 = /*#__PURE__*/React.createElement("path", {
    fill: "url(#oinq-money-happy_svg__c)",
    d: "m80.91 61.083 3.265-1.03 1.074 5.899-3.082.906z"
  })), _path1 || (_path1 = /*#__PURE__*/React.createElement("path", {
    fill: "#2DE878",
    d: "M80.815 60.627s1.09 5.417 1.968 5.894-1.761.35-1.761.35l-2.333-3.747.021-2.184z"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    fill: "#EDBF00",
    d: "M78.732 58.685c1.208 4.108 3.307 7.11 4.687 6.704 1.38-.405 1.518-4.065.31-8.174-1.209-4.108-3.308-7.11-4.687-6.705s-1.519 4.066-.31 8.175"
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    fill: "#FFE36C",
    d: "M79.973 58.372c1.208 4.109 3.033 7.192 4.071 6.886 1.039-.305.904-3.885-.305-7.993-1.209-4.11-3.034-7.192-4.072-6.886-1.038.305-.903 3.885.306 7.993"
  })), _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    fill: "#FFD400",
    d: "M79.972 58.374c1.209 4.108 3.034 7.191 4.072 6.886 1.038-.306.903-3.885-.305-7.994a27 27 0 0 0-1.305-3.553z"
  })), _path13 || (_path13 = /*#__PURE__*/React.createElement("path", {
    fill: "#2DE878",
    d: "M84.108 59.919s.89 5.214.412 6.095c-.48.877 1.67-.66 1.67-.66l-.068-4.413-1.2-1.824z"
  })), _path14 || (_path14 = /*#__PURE__*/React.createElement("path", {
    fill: "#77E4A6",
    d: "M99.226 54.619a.7.7 0 0 1-.398.023 1.5 1.5 0 0 1-.483-.179c-7.131-4.008-8.812-.118-8.881.046a.34.34 0 0 1-.156.169.55.55 0 0 1-.27.06 1.4 1.4 0 0 1-.704-.223 1.7 1.7 0 0 1-.571-.548.64.64 0 0 1-.104-.551c.024-.052 2.197-5.088 11.036-.121q.344.196.573.522a.69.69 0 0 1 .142.55.34.34 0 0 1-.184.252M63.574 65.325a.4.4 0 0 1-.292.002.42.42 0 0 1-.193-.392c.002-.223.055-.441.164-.636 4.298-8.08 8.85-6.59 8.893-6.574a.3.3 0 0 1 .155.128c.04.072.064.154.07.236a.9.9 0 0 1-.031.31 2 2 0 0 1-.12.337 2 2 0 0 1-.198.31 1.4 1.4 0 0 1-.242.238.8.8 0 0 1-.25.128.37.37 0 0 1-.22 0c-.15-.049-3.68-1.163-7.13 5.32a1.7 1.7 0 0 1-.284.375.8.8 0 0 1-.322.218"
  })), _path15 || (_path15 = /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "M82.814 75.28c1.906 4.512.84 9.28-2.377 10.647s-7.372-1.178-9.278-5.691-.84-9.28 2.376-10.648c3.217-1.368 7.373 1.18 9.279 5.692"
  })), _path16 || (_path16 = /*#__PURE__*/React.createElement("path", {
    fill: "#0C1C2C",
    d: "M79.809 83.046c1.674-.712 2.45-2.66 1.734-4.355s-2.65-2.49-4.325-1.778-2.45 2.66-1.734 4.355 2.654 2.488 4.325 1.778"
  })), _path17 || (_path17 = /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "M78.271 79.639a.66.66 0 0 0 .406-.626.68.68 0 0 0-.42-.621.664.664 0 0 0-.906.496.7.7 0 0 0 .043.39.67.67 0 0 0 .877.36M102.836 70.353c.874 5.854-1.809 11.094-5.989 11.705-4.18.61-8.28-3.64-9.153-9.494-.874-5.855 1.809-11.095 5.989-11.705s8.279 3.64 9.153 9.494"
  })), _path18 || (_path18 = /*#__PURE__*/React.createElement("path", {
    fill: "#0C1C2C",
    d: "M97.09 77.128c1.966-.751 2.944-2.968 2.187-4.958s-2.96-2.991-4.925-2.24c-1.967.752-2.945 2.969-2.187 4.959.757 1.99 2.964 2.99 4.925 2.24"
  })), _path19 || (_path19 = /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "M95.776 73.493a.703.703 0 0 0 .3-1.04.7.7 0 0 0-.716-.294.69.69 0 0 0-.54.554.7.7 0 0 0 .044.405c.15.357.56.525.912.375"
  })), _path20 || (_path20 = /*#__PURE__*/React.createElement("path", {
    fill: "#0C1C2C",
    d: "m82.636 115.203 5.082-.542c6.416-.713 13.143-2.297 20.204-7.127l4.646-3.443c2.912-1.082 5.919 1.408 5.441 4.506-1.111 7.196-4.855 15.845-11.076 21.058-7.69 6.442-18.588-.595-25.716-7.64-2.149-2.124-1.39-5.769 1.419-6.812"
  })), /*#__PURE__*/React.createElement("mask", {
    id: "oinq-money-happy_svg__d",
    width: 40,
    height: 30,
    x: 79,
    y: 103,
    maskUnits: "userSpaceOnUse",
    style: {
      maskType: "luminance"
    }
  }, _path21 || (_path21 = /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "m82.636 115.203 5.082-.542c7.7-.827 14.575-3.136 20.733-7.508l4.117-3.062c2.912-1.082 5.919 1.408 5.441 4.506-1.111 7.196-4.855 15.845-11.076 21.058-7.69 6.442-18.588-.595-25.716-7.64-2.149-2.124-1.39-5.769 1.419-6.812"
  }))), /*#__PURE__*/React.createElement("g", {
    mask: "url(#oinq-money-happy_svg__d)"
  }, _path22 || (_path22 = /*#__PURE__*/React.createElement("path", {
    fill: "#FF495C",
    d: "M88.609 131.415s11.538-14.126 27.686-8.089c0 0-8.357 18.827-27.686 8.089"
  })), /*#__PURE__*/React.createElement("mask", {
    id: "oinq-money-happy_svg__e",
    width: 40,
    height: 32,
    x: 79,
    y: 103,
    maskUnits: "userSpaceOnUse",
    style: {
      maskType: "luminance"
    }
  }, _path23 || (_path23 = /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "m82.696 115.163 2.428-.219c9.73-1.605 17.087-4.723 24.587-9.023l2.917-1.87c2.912-1.081 5.919 1.408 5.441 4.506-1.111 7.197-3.777 18.214-9.998 23.427-7.69 6.441-19.666-2.963-26.794-10.009-2.149-2.123-1.638-5.686 1.42-6.812"
  }))), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#oinq-money-happy_svg__e)"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "m120.772 102.204-6.364 5.614-1.82-.295-.249 1.52-2.369 1.505c-7.334 4.614-19.077 7.136-32.695 9.115l-.357.052-2.233-2.795 44.237-19.308z"
  })))), _path24 || (_path24 = /*#__PURE__*/React.createElement("path", {
    fill: "#28CC6F",
    d: "M78.197 85.016s-8.634 5.392-9.394 15.869c-.577 7.327 4.97 15.9 14.322 11.279s14.938-6.341 20.885-6.713c5.946-.372 13.476-4.274 13.352-9.504-.122-5.224-2.844-12.634-10.678-15.584s-18.144-2.856-28.487 4.653"
  })), _path25 || (_path25 = /*#__PURE__*/React.createElement("path", {
    fill: "#43DB85",
    d: "M71.306 104.253s1.763 8.385 9.515 6.336 11.312-6.015 24.416-7.848c13.107-1.827 11.077-10.381 6.814-16.013-4.263-5.631-14.842-8.194-24.574-4.918-9.734 3.27-17.765 11.214-16.17 22.443"
  })), _path26 || (_path26 = /*#__PURE__*/React.createElement("path", {
    fill: "#34C66F",
    d: "M106.176 90.74c.731 2.747-.599 5.48-2.92 6.088s-4.822-1.102-5.552-3.85c-.728-2.74.579-5.472 2.92-6.089 2.344-.61 4.828 1.117 5.552 3.85"
  })), _path27 || (_path27 = /*#__PURE__*/React.createElement("path", {
    fill: "#0C1C2C",
    d: "M107.306 91.397c.727 2.74-.583 5.465-2.928 6.091-2.338.624-4.825-1.109-5.552-3.85-.73-2.747.582-5.465 2.92-6.089 2.338-.623 4.825 1.093 5.56 3.847"
  })), _path28 || (_path28 = /*#__PURE__*/React.createElement("path", {
    fill: "#34C66F",
    d: "M85.142 98.357c.73 2.747-.6 5.481-2.92 6.089-2.32.607-4.822-1.103-5.553-3.85-.727-2.74.579-5.473 2.92-6.09 2.344-.61 4.828 1.117 5.553 3.85"
  })), _path29 || (_path29 = /*#__PURE__*/React.createElement("path", {
    fill: "#0C1C2C",
    d: "M86.27 99.014c.728 2.74-.581 5.465-2.926 6.092-2.338.624-4.825-1.11-5.553-3.85-.73-2.748.582-5.466 2.92-6.09s4.826 1.093 5.56 3.848"
  })), _path30 || (_path30 = /*#__PURE__*/React.createElement("path", {
    fill: "#EDBF00",
    d: "M69.61 42.478c1.15 3.903 3.143 6.755 4.454 6.37 1.31-.386 1.443-3.863.295-7.767-1.149-3.903-3.143-6.755-4.454-6.37-1.31.386-1.442 3.864-.294 7.767"
  })), _path31 || (_path31 = /*#__PURE__*/React.createElement("path", {
    fill: "#FFE36C",
    d: "M70.79 42.184c1.148 3.903 2.881 6.832 3.868 6.542.986-.29.858-3.691-.29-7.595s-2.882-6.832-3.869-6.542c-.986.29-.858 3.691.29 7.595"
  })), _path32 || (_path32 = /*#__PURE__*/React.createElement("path", {
    fill: "#FFD400",
    d: "M70.79 42.184c1.148 3.903 2.882 6.832 3.868 6.542.987-.29.858-3.691-.29-7.595-.367-1.25-.795-2.4-1.24-3.376z"
  })), _path33 || (_path33 = /*#__PURE__*/React.createElement("path", {
    fill: "#EDBF00",
    d: "M76.757 32.42c.8 2.72 2.19 4.709 3.103 4.44s1.006-2.693.206-5.413-2.19-4.709-3.104-4.44-1.006 2.693-.205 5.413"
  })), _path34 || (_path34 = /*#__PURE__*/React.createElement("path", {
    fill: "#FFE36C",
    d: "M77.578 32.212c.8 2.72 2.009 4.762 2.696 4.56s.598-2.572-.202-5.293-2.009-4.762-2.696-4.56-.598 2.573.202 5.293"
  })), _path35 || (_path35 = /*#__PURE__*/React.createElement("path", {
    fill: "#FFD400",
    d: "M77.578 32.212c.8 2.72 2.009 4.762 2.696 4.56s.598-2.573-.202-5.293a18 18 0 0 0-.864-2.353z"
  })), _path36 || (_path36 = /*#__PURE__*/React.createElement("path", {
    fill: "#EDBF00",
    d: "M67.878 22.662c.656 2.226 1.793 3.854 2.541 3.634s.823-2.204.168-4.431-1.793-3.854-2.54-3.634-.824 2.204-.169 4.43"
  })), _path37 || (_path37 = /*#__PURE__*/React.createElement("path", {
    fill: "#FFE36C",
    d: "M68.55 22.493c.656 2.227 1.645 3.898 2.208 3.732s.49-2.106-.166-4.333c-.655-2.226-1.644-3.897-2.207-3.732-.562.166-.49 2.106.166 4.333"
  })), _path38 || (_path38 = /*#__PURE__*/React.createElement("path", {
    fill: "#FFD400",
    d: "M68.55 22.492c.656 2.227 1.645 3.898 2.207 3.733.563-.166.49-2.106-.165-4.333-.21-.713-.454-1.37-.707-1.926z"
  }))), _ellipse || (_ellipse = /*#__PURE__*/React.createElement("ellipse", {
    cx: 98.65,
    cy: 155.305,
    fill: "#EFEFEF",
    rx: 39.993,
    ry: 4.222
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "oinq-money-happy_svg__c",
    x1: 18.073,
    x2: 18.369,
    y1: 85.436,
    y2: 85.337,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#242929"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#242929"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "oinq-money-happy_svg__a"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "M0 36.463 136.084-.001l35.812 133.651-136.084 36.464z"
  })))));
};
export default SvgOinqMoneyHappy;